import {RichTextOptions} from '@gongxigames/framework/core/fragments/display';
import {TextStyle} from 'pixi.js';

export type HitArea = {
    x: number;
    y: number;
};

export type CircleHitArea = HitArea & {
    type: 'circle';
    radius: number;
};

export type RectangleHitArea = HitArea & {
    type: 'rectangle';
    width: number;
    height?: number;
};

export type DisplayObjectConfig = {
    x?: number;
    y?: number;
    width?: number;
    height?: number;
    scaleX?: number;
    scaleY?: number;
    flipH?: boolean;
    flipV?: boolean;
    anchor?: {x?: number; y?: number;};
    name?: string;
    mask?: [number, number, number, number];
    visible?: boolean;
    type?: string;
};

export type ImageConfig = DisplayObjectConfig & {
    src: string;
    xAnchor?: number;
    yAnchor?: number;
};

export type GraphicConfig = DisplayObjectConfig & {
    type: 'graphic';
    radius?: number;
    width?: number;
    height?: number;
    alpha?: number;
    color: string;
};

export type TextConfig = DisplayObjectConfig & {
    type: 'text';
    style: any;
    text: string;
    xAnchor?: number;
    yAnchor?: number;
    localeTextID?: string;
    maxWidth?: number;
};

/**
 * @deprecated Use RichText instead
 */
export type AdvancedTextConfig = {
    id?: string;
    text?: string;
    style?: TextStyle;
    maxWidth?: number;
};

export type ButtonConfig = DisplayObjectConfig & {
    frames: [DisplayObjectsConfig, DisplayObjectsConfig, DisplayObjectsConfig, DisplayObjectsConfig];
    hitarea?: CircleHitArea | RectangleHitArea;
};

export type SpineButtonConfig = DisplayObjectConfig & {
    spineName: string;
    animationNames: {
        hoverStart: string;
        hoverEnd: string;
        click: string;
        idle?: string;
    };
    clickCallback?: Function;
    trackIndex?: number;
    hitarea?: CircleHitArea | RectangleHitArea;
};

export type SlotConfig = DisplayObjectConfig & {
    name: string;
    sprite?: {
        rootSprite: string;
        treeName: string;
        prefix?: string;
    };
    text?: AdvancedTextConfig;
    richText?: RichTextOptions;
};

export type SpineConfig = DisplayObjectConfig & Required<Pick<DisplayObjectConfig, 'name'>> & {
    slots?: SlotConfig[];
};

export type TweenConfig = {
    chain?: TweenConfig[];
    to: number;
    time: number;
    delay?: number;
    easing: string;
    yoyo?: boolean;
    repeat: number | null | 'Infinity';
};

export type BaseMovieClipConfig = DisplayObjectConfig & {
    frames: DisplayObjectsConfig[];
};

export type MovieClipConfig = BaseMovieClipConfig & {
    type: 'movieclip';
};

export type FrameAnimationConfig = BaseMovieClipConfig& {
    type: 'frame_animation';
    fps?: number;
    delay?: number;
    repeat: number | null | 'Infinity';
    tweens?: TweenConfig[];
};

export type TweenAnimationConfig = DisplayObjectConfig & {
    type: 'movieclip';
    tweens?: TweenConfig[];
};

export type DisplayObjectsConfig = | ImageConfig
                                   | MovieClipConfig
                                    | ButtonConfig
                                    | TextConfig
                                    | TweenAnimationConfig
                                    | FrameAnimationConfig;
